import { ChartDatum } from "./roi-chart";

export type RoiTimeSeriesData = {
  timeLabelString: string;
  external: {
    averageDurationInMinutes: number;
    averageCharge: number;
    averageCost: number;
    averageRecovered: number;
    gpm: number;
    writeOff: number;
    writeOffPercentage: number;
    averageTotalCharge: number;
  };
  vpd: {
    averageDurationInMinutes: number;
    averageCharge: number;
    averageCost: number;
    averageRecovered: number;
    gpm: number;
    writeOff: number;
    writeOffPercentage: number;
    averageTotalCharge: number;
  } | null;
  notVpd: {
    averageDurationInMinutes: number;
    averageCharge: number;
    averageCost: number;
    averageRecovered: number;
    gpm: number;
    writeOff: number;
    writeOffPercentage: number;
    averageTotalCharge: number;
  } | null;
  cumulativeVpdRevenue?: number;
  cumulativeVpdProfit?: number;
  cumulativePotentialRevenue?: number;
  cumulativePotentialProfit?: number;
  externalMatterCount: number;
  vpdMatterCount: number;
};

export function prepareChartData(roiTimeSeriesData: RoiTimeSeriesData[]) {
  const vpdRoiTimeSeriesData = roiTimeSeriesData.filter(
    (item: RoiTimeSeriesData) => item.vpd !== null
  );

  const externalMatterCountData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.externalMatterCount,
      source: "external",
    })) || [];

  const vpdMatterCountData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.vpdMatterCount,
      source: "vpd",
    })) || [];

  // const externalRollingAgreedRateData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y:
  //       item.external.averageDurationInMinutes > 0
  //         ? (item.external.averageCharge * 60) / item.external.averageDurationInMinutes
  //         : 0,
  //     source: "external",
  //   })) || [];

  const vpdRollingAgreedRateData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y:
        item.vpd!.averageDurationInMinutes > 0
          ? (item.vpd!.averageCharge * 60) / item.vpd!.averageDurationInMinutes
          : 0,
      source: "vpd",
    })) || [];
  const notVpdRollingAgreedRateData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y:
        item.notVpd!.averageDurationInMinutes > 0
          ? (item.notVpd!.averageCharge * 60) / item.notVpd!.averageDurationInMinutes
          : 0,
      source: "notVpd",
    })) || [];

  // const externalRollingRecoveredRateData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: (item.external.averageRecovered * 60) / item.external.averageDurationInMinutes,
  //     source: "external",
  //   })) || [];

  const vpdRollingRecoveredRateData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y:
        item.vpd!.averageDurationInMinutes > 0
          ? (item.vpd!.averageRecovered * 60) / item.vpd!.averageDurationInMinutes
          : 0,
      source: "vpd",
    })) || [];

  const notVpdRollingRecoveredRateData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y:
        item.notVpd!.averageDurationInMinutes > 0
          ? (item.notVpd!.averageRecovered * 60) / item.notVpd!.averageDurationInMinutes
          : 0,
      source: "notVpd",
    })) || [];

  // const externalGpmData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.external.gpm,
  //     source: "external",
  //   })) || [];

  const vpdGpmData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.vpd!.gpm,
      source: "vpd",
    })) || [];

  const notVpdGpmData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.notVpd!.gpm,
      source: "notVpd",
    })) || [];

  // const externalWriteOffData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.external.writeOff,
  //     source: "external",
  //   })) || [];

  // const vpdWriteOffData: Array<ChartDatum> =
  //   vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.vpd!.writeOff,
  //     source: "vpd",
  //   })) || [];

  // const notVpdWriteOffData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.notVpd!.writeOff,
  //     source: "notVpd",
  //   })) || [];

  // const externalWriteOffPercentageData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.external.writeOffPercentage,
  //     source: "external",
  //   })) || [];

  const vpdWriteOffPercentageData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.vpd!.writeOffPercentage,
      source: "vpd",
    })) || [];

  const notVpdWriteOffPercentageData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.notVpd!.writeOffPercentage,
      source: "notVpd",
    })) || [];

  // const cumulativeVpdRevenueData: Array<ChartDatum> =
  //   vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.cumulativeVpdRevenue ?? 0,
  //     source: "vpd",
  //   })) || [];

  const cumulativeVpdProfitData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.cumulativeVpdProfit ?? 0,
      source: "vpd",
    })) || [];

  // const externalTotalChargeData: Array<ChartDatum> =
  //   roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
  //     x: item.timeLabelString,
  //     y: item.external.averageTotalCharge,
  //     source: "external",
  //   })) || [];

  const vpdTotalChargeData: Array<ChartDatum> =
    vpdRoiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.vpd!.averageTotalCharge,
      source: "vpd",
    })) || [];

  const notVpdTotalChargeData: Array<ChartDatum> =
    roiTimeSeriesData?.map((item: RoiTimeSeriesData) => ({
      x: item.timeLabelString,
      y: item.notVpd!.averageTotalCharge,
      source: "notVpd",
    })) || [];

  return {
    cumulativeVpdProfitData: cumulativeVpdProfitData,
    // cumulativeVpdRevenueData: cumulativeVpdRevenueData,
    externalMatterCountData: externalMatterCountData,
    vpdMatterCountData: vpdMatterCountData,
    vpdGpmData: vpdGpmData,
    notVpdGpmData: notVpdGpmData,
    vpdRollingAgreedRateData: vpdRollingAgreedRateData,
    notVpdRollingAgreedRateData: notVpdRollingAgreedRateData,
    vpdRollingRecoveredRateData: vpdRollingRecoveredRateData,
    notVpdRollingRecoveredRateData: notVpdRollingRecoveredRateData,
    vpdWriteOffPercentageData: vpdWriteOffPercentageData,
    notVpdWriteOffPercentageData: notVpdWriteOffPercentageData,
    vpdTotalChargeData: vpdTotalChargeData,
    notVpdTotalChargeData: notVpdTotalChargeData,
  };
}
